<template>
    <modal-component id="autorenewaLearnMoreModal" :shown="shown" :handle-cancel="close" size="lg">
        <template v-slot:header>
            {{ i18n.learnMoreTitle }}
        </template>
        <template v-slot:body>
            <p>{{ i18n.learnMoreIntro }} {{ freeCouponThreshold }} {{ i18n.learnMoreIntro2 }}</p>
            <p>{{ i18n.learnMoreActivateListTitle }}</p>
            <ul>
                <li>{{ i18n.learnMoreActivateList[0] }}</li>
                <li>{{ i18n.learnMoreActivateList[1] }}</li>
                <li>{{ i18n.learnMoreActivateList[2] }}</li>
                <li>{{ i18n.learnMoreActivateList[3] }}</li>
            </ul>
            <p class="mt-2">{{ i18n.learnMoreCancelListTitle }}</p>
            <p>{{ i18n.learnMoreCancelListSubtitle }}</p>
            <ul>
                <li>{{ i18n.learnMoreCancelList[0] }}</li>
                <li>{{ i18n.learnMoreCancelList[1] }}</li>
            </ul>
            <p class="mt-2"><small>{{ i18n.learnMoreFootnote }}</small></p>
        </template>
        <template v-slot:footer>
            <button type="button" class="btn btn-primary btn-block" @click="close">
                {{ i18n.ok }}
            </button>
        </template>
    </modal-component>
</template>

<script>
// import Translations from "./insert-me-to-translate.vue";
import { getLightboxName } from '../../../utils';

import ModalComponent from '../../modal-component.vue'

export default {
    name: 'LightboxAutoRenewalLearnMore',
    components: {
        ModalComponent,
    },
    props: {
        freeCouponThreshold: {
            type: Number,
            default: 10,
        }
    },
    data() {
        return {
            lightboxName: null,
            i18n: {
                learnMoreTitle: gettext('What is auto-renewal?'),
                learnMoreIntro: gettext('Auto-renewal refers to the automatic continuation of an ad promotion, for the days chosen by you. No more need to buy a promotion every day, no any further effort from your side. And more... after'),
                learnMoreIntro2: gettext('renewals you will receive a free coupon for the same product!'),
                learnMoreActivateListTitle: gettext('How to activate auto-renewal?'),
                learnMoreActivateList: [
                    gettext('You can simply charge the credit wallet and prepare your ad.'),
                    gettext('Then select the product and the time slot to promote it.'),
                    gettext('Finally switch on the auto-renewal button.'),
                    gettext('Now the promo will be renewed until you have credits in your wallet or you deactivate the auto-renewal.'),
                ],
                learnMoreCancelListTitle: gettext('How to cancel auto-renewal?'),
                learnMoreCancelListSubtitle: gettext('Auto-renewal can be canceled:'),
                learnMoreCancelList: [
                    gettext('automatically, if you have no more credits in your wallet.'),
                    gettext('manually, if you deactivate the auto-renewal into "manage your ad" page.')
                ],
                learnMoreFootnote: gettext('*The amount of requested renewals for a FREE coupon depends on the product choosen for the auto-renewal.'),
                ok: gettext('Ok'),
            }
        };
    },
    computed: {
        shown() {
            return this.$store.getters['ui/lightboxManager/lightboxIsShown'](this.lightboxName);
        }
    },
    mounted() {
        this.lightboxName = getLightboxName({ el: this.$el })
    },
    methods: {
        close() {
            this.$store.dispatch("ui/lightboxManager/hide", this.lightboxName);
        }
    }
}
</script>